<template>
  <v-card rounded="xl">
    <v-dialog v-model="alertDialog" max-width="400" persistent>
      <v-card class="pa-4" rounded="lg">
        <v-card-title class="text-center d-block">
          註冊成功
        </v-card-title>
        <v-card-actions class="mt-2 px-4 px-md-6">
          <div style="width: 100%;">
            <v-btn color="tiffany-9" dark block @click="login">
              進入CRM系統
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center py-7 white--text" style="background: transparent linear-gradient(76deg, #33B6B0 0%, #3ED3CC 100%) 0 0 no-repeat padding-box;">
      <h2 class="font-weight-bold mb-2">醫師註冊</h2>
      <div class="text-subtitle-1 font-weight-regular">打造專屬線上預約頁面，提升醫病互動體驗</div>
    </div>
    <v-card-text class="pb-7 px-0 pt-0">
      <v-row no-gutters class="tiffany-1 py-7 px-4 px-md-12" style="row-gap: 20px;">
        <v-col cols="12" class="tiffany-9--text text-center mb-2">註冊後你將能夠「免費獲得」</v-col>
        <v-col cols="12" class="mb-4">
          <v-card outlined max-width="388" class="d-flex align-center justify-center pa-5 rounded-lg ma-auto" style="column-gap: 20px;">
            <div>
              <v-img
                :src="assetURL('/asset/crm/Rectangle 981@2x.png')"
                max-width="100"
              />
            </div>
            <div>
              <div class="font-weight-medium mb-1">✅ 編輯你的專屬醫師頁面</div>
              <div class="text-body-2 grey-5--text">
                打造網路個人形象，讓患者更認識你
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-4">
          <v-card outlined max-width="388" class="d-flex align-center justify-center pa-5 rounded-lg ma-auto" style="column-gap: 20px;">
            <div>
              <v-img
                :src="assetURL('/asset/crm/Rectangle 987@2x.png')"
                max-width="100"
              />
            </div>
            <div>
              <div class="font-weight-medium mb-1">✅ 管理網路評價，建立信任感</div>
              <div class="text-body-2 grey-5--text">
                集中 Google 評價與小幫手評價回饋，輕鬆掌握病人口碑
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-4">
          <v-card outlined max-width="388" class="d-flex align-center justify-center pa-5 rounded-lg ma-auto" style="column-gap: 20px;">
            <div>
              <v-img
                :src="assetURL('/asset/crm/Rectangle 990@2x.png')"
                max-width="100"
              />
            </div>
            <div>
              <div class="font-weight-medium mb-1">✅ 同步診所預約，隨時掌握接診狀況</div>
              <div class="text-body-2 grey-5--text">
                若診所已開通系統，醫師將能即時查看自己的約診安排
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" class="px-4">
        <v-sheet max-width="388" class="ma-auto py-7">
          <v-row no-gutters class="flex-column" style="row-gap: 20px;">
            <v-col cols="12">
              <v-text-field
                :label="$t('RegisterDoctorForm.doctorName')"
                v-model.trim="registerData.name"
                hide-details="auto"
                :rules="[v => !!v || $t('RegisterDoctorForm.inputDoctorName')]"
                required
                dense
                outlined
                autocomplete="name"
              />
            </v-col>

            <v-col cols="12">
              <v-select
                :label="$t('RegisterDoctorForm.gender')"
                v-model.trim="registerData.sex"
                hide-details="auto"
                :rules="[v => v !== null || $t('RegisterDoctorForm.inputGender')]"
                :items="gender"
                required
                dense
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                label="Email"
                v-model.trim="registerData.email"
                hide-details="auto"
                ref="emailField"
                :rules="emailRule"
                required
                dense
                outlined
                autocomplete="email"
              />
            </v-col>

            <!-- ✅ 手機與驗證碼按鈕共一 row，並設 col 間距 -->
            <v-row no-gutters class="justify-center flex-nowrap" style="column-gap: 10px;">
              <v-col cols="auto" class="flex-grow-1">
                <v-text-field
                  :label="$t('RegisterDoctorForm.phone')"
                  v-model.trim="registerData.phone"
                  hide-details="auto"
                  ref="phoneField"
                  :rules="phoneRule"
                  required
                  dense
                  outlined
                  autocomplete="tel"
                />
              </v-col>
              <v-col cols="auto" class="flex-shrink-0">
                <v-btn block color="primary" :disabled="disabledSendOTP" @click="sendOtp">
                  {{ timerCount > 0 ? timerCount : $t('RegisterDoctorForm.sendOtp') }}
                </v-btn>
              </v-col>
            </v-row>

            <v-col v-if="showOtp" cols="12">
              <v-text-field
                :label="$t('RegisterDoctorForm.otp')"
                v-model.trim="registerData.otp_code"
                hide-details="auto"
                :rules="[v => !!v || $t('RegisterDoctorForm.inputOtp')]"
                :prefix="prefix"
                required
                dense
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('RegisterDoctorForm.password')"
                v-model.trim="registerData.password"
                required
                :rules="[v => !!v || $t('RegisterDoctorForm.inputPassword')]"
                hide-details="auto"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                dense
                outlined
                autocomplete="new-password"
                @click:append="showPassword = !showPassword"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :label="$t('RegisterDoctorForm.confirmPassword')"
                v-model.trim="registerData.password2"
                required
                :rules="[
                  v => !!v || $t('RegisterDoctorForm.inputConfirmPassword'),
                  v => v === registerData.password || $t('RegisterDoctorForm.inputConfirmPassword2')
                ]"
                hide-details="auto"
                :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword2 ? 'text' : 'password'"
                dense
                outlined
                validate-on-blur
                autocomplete="new-password"
                @click:append="showPassword2 = !showPassword2"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="clinic"
                label="請選擇工作診所（可稍後設定）"
                :items="clinicItems"
                :loading="loading"
                return-object
                item-text="show"
                hide-details="auto"
                hide-no-data
                :placeholder="$t('RegisterDoctorForm.clinicDoctorPH')"
                :search-input.sync="search"
                :hint="$t('RegisterDoctorForm.clinicDoctorHint')"
                clearable
                dense
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-btn block :disabled="!valid || !registerData.otp_code" color="primary" @click="submit">
                {{ $t('RegisterDoctorForm.confirm') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
      </v-form>
      <div class="px-4">
        <v-sheet max-width="388" class="ma-auto">
          <div>
            <span class="black--text">若您已有帳號？</span>
            <v-btn small text dark color="tiffany-9" @click="$emit('close')">前往登入</v-btn>
          </div>
          <v-card
            class="px-5 pb-7 pt-4 mt-5"
            outlined
            rounded="lg"
            style="border-color: #00B7A8; background-color: var(--v-tiffany-1-base);"
          >
            <div>
              <div class="d-flex align-center">
                <div
                  class="d-flex align-center justify-center mr-4 tiffany-9"
                  style="min-width: 32px; height: 32px; border-radius: 50%;"
                >
                  <v-icon color="white">mdi-lightbulb-on</v-icon>
                </div>
                <div class="font-weight-medium tiffany-9--text">
                  為什麼需要註冊？
                </div>
              </div>
              <div class="text-body-2 black--text mt-2" style="line-height: 2">
                ✅ 系統會自動產出你的專屬頁面，需要登入才能編輯<br>
                ✅ 註冊後立刻創建醫師頁面（不綁診所也可以）<br>
                ✅ 後續可連結 LINE 官方帳號，提高醫病互動
              </div>
            </div>
          </v-card>
        </v-sheet>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getMedicalCategoryAPI, loginAPI, registerDoctorAPI, searchClinicAPI, sendOtpAPI } from "@/api";
import { assetURL } from "@/utils/filters";
import { mapMutations } from "vuex";
import { sendDiscordAlert } from "@/utils/tool";

export default {
  name: "RegisterDoctorFormV2",
  data() {
    return {
      valid: true,
      showPassword: false,
      showPassword2: false,
      showOtp: false,
      timerCount: 0,
      disabledSendOTP: true,
      prefix: null,
      clinicItems: [],
      search: null,
      loading: false,
      gender: [
        {text: this.$t('RegisterDoctorForm.male'), value: 1},
        {text: this.$t('RegisterDoctorForm.female'), value: 0}
      ],
      registerData: {
        name: '',
        phone: '',
        password: '',
        password2: '',
        otp_code: '',
        sex: null,
        kind: null
      },
      clinic: null,
      phoneRule: [
        v => !!v || this.$t('RegisterDoctorForm.inputPhone'),
        v => (v.startsWith('09') && v.trim().length === 10) || this.$t('RegisterDoctorForm.inputPhoneFormat')
      ],
      emailRule: [
        v => !!v || this.$t('RegisterDoctorForm.inputEmail'),
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('RegisterDoctorForm.inputEmailFormat')
      ],
      medicalCategories: [],

      alertDialog: false
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        } else {
          this.disabledSendOTP = false
        }
      },
      immediate: true
    },
    search(v) {
      if (v) this.searchClinic(v)
    },
    'registerData.phone': {
      handler() {
        this.disabledSendOTP = !(this.$refs.phoneField.validate() && this.timerCount <= 0);
      }
    }
  },
  methods: {
    ...mapMutations({
      setUserData: 'setUserData'
    }),
    assetURL,
    submit() {
      this.$refs.form.validate()
      if (!this.valid) return
      if (this.registerData.password2 !== this.registerData.password) {
        return
      }
      if (this.clinic)
        this.registerData.clinic_code = this.clinic.clinic_code
      registerDoctorAPI(this.registerData).then(() => {
        this.$gtm.trackEvent({
          event: 'sign_up',
          doctor_name: this.registerData.name,
          datetime: new Date().toISOString()
        })

        this.alertDialog = true
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.messages) {
          alert(e.response.data.messages)
        } else {
          alert(this.$t('GENERAL.oops'))
          console.error(e)
        }
      })
    },
    login() {
      const data = {
        account: this.registerData.phone,
        type: 2,
      }
      loginAPI({
        password: this.registerData.password,
        ...data
      }).then(async res => {
        this.setUserData(res.data)
        await this.$store.dispatch('loadUserInfo', { force: true })
          .catch(err => console.error('loadUserInfo failed after register login', err))
        localStorage.setItem('isNewUser', 'true');
        this.$router.push('/')
      }).catch(e => {
        if (e.response) {
          // 有打到後端（後端錯誤）
          const messages = e.response.data?.messages

          if (messages) {
            // 後端有提供明確錯誤訊息
            alert(messages)
          } else {
            // 有打到後端，但後端沒有提供錯誤訊息
            alert(this.$t('GENERAL.oops'))
            console.error('後端錯誤但無訊息:', e.response)

            try {
              const errorInfo = JSON.stringify({
                message: e.message,
                stack: e.stack,
                code: e.code,
                responseStatus: e.response?.status,
                responseData: e.response?.data,
              }, null, 2)

              const dataInfo = JSON.stringify(data, null, 2)
              sendDiscordAlert(
                `登入發生錯誤：後端有回應但未提供錯誤訊息。\ndata: ${dataInfo}\nerror: ${errorInfo}`
              )
            } catch (alertErr) {
              console.error('sendDiscordAlert 發送失敗:', alertErr)
              // ❗但不做 alert，不打擾使用者
            }
          }
        } else if (e.message === 'Network Error') {
          // 沒有網路 / 無法連線到伺服器
          alert('網路錯誤，請確認您的連線')
        } else if (e.code === 'ECONNABORTED') {
          // 請求逾時
          alert('請求逾時，請稍後再試')
        } else {
          // 其他未知錯誤（可能是 CORS 問題或前端程式錯誤）
          alert('發生未知錯誤，請稍後再試')
          console.error('未知錯誤:', e)

          try {
            const errorInfo = JSON.stringify({
              message: e.message,
              stack: e.stack,
              code: e.code,
              responseStatus: e.response?.status,
              responseData: e.response?.data,
            }, null, 2)

            const dataInfo = JSON.stringify(data, null, 2)
            sendDiscordAlert(
              `登入發生未知錯誤。\ndata: ${dataInfo}\nerror: ${errorInfo}`
            )
          } catch (alertErr) {
            console.error('sendDiscordAlert 發送失敗:', alertErr)
            // ❗但不做 alert，不打擾使用者
          }
        }
      })
    },
    sendOtp() {
      const data = {
        phone: this.registerData.phone,
        suffix_message: this.$t('RegisterDoctorForm.suffixMessage')
      }
      this.disabledSendOTP = true
      this.timerCount = 30
      sendOtpAPI(data).then(res => {
        if (res.data.status === -1) {
          alert(res.data.message)
          this.timerCount = 0
          this.disabledSendOTP = false
          return
        }
        this.showOtp = true
        this.prefix = `${res.data.prefix} -`
      }).catch((e) => {
        if (e.response && e.response.data && e.response.data.status === -1) {
          alert(e.response.data.message || this.$t('GENERAL.oops'))
        } else {
          alert(this.$t('GENERAL.oops'))
        }
        this.disabledSendOTP = false
        this.timerCount = 0
      })
    },
    searchClinic(v) {
      this.loading = true
      searchClinicAPI({clinic_name: v}).then(res => {
        const clinicItems = res.data
        this.clinicItems = clinicItems.map(v => {
          return {...v, show: `${v.clinic_name}(${v.address})`}
        })
      }).finally(() => {
        this.loading = false
      })
    },
    getMedicalList() {
      getMedicalCategoryAPI().then(res => {
        this.medicalCategories = res.data
      })
    }
  },
  mounted() {
    this.getMedicalList()
  }
}
</script>

<style scoped>

</style>